import { render } from "./ApproveSupplierInvoice.vue?vue&type=template&id=a93ee94a"
import script from "./ApproveSupplierInvoice.vue?vue&type=script&lang=js"
export * from "./ApproveSupplierInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__